import { Slot } from './billingAndServiceOffering';

export const DISMISSED_JOIN_NOW_APPOINTMENT_IDS =
  'dismissedJoinNowAppointments';

export const APPOINTMENT_DURATIONS = [15, 30, 60] as Slot[];
